<template>
  <div class="statistics-resource">
    <div class="title">
      <img src="@/assets/img/icon/icon18.png" alt="" />资源完成个数
    </div>
    <div
      ref="main"
      style="
        width: 100%;
        height: 300px;
        display: flex;
        align-items: center;
        padding: 0 24px;
      "
    ></div>
  </div>
</template>

<script>
import * as echarts from "echarts";

export default {
  props: {
    info: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      data: [],
    };
  },
  methods: {
    init() {
      const myChart = echarts.init(this.$refs.main);
      const option = {
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: ["DOC", "图片", "PDF", "PPT", "视频", "音频"],
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            data: this.data,
            type: "line",
            symbol: "none",
            lineStyle: {
              // 设置线条的style等
              normal: {
                color: "#FF7C15", // 折线线条颜色:红色
              },
            },
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "#FF7C15", // 100% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#FFFFFF", //   0% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
          },
        ],
      };
      myChart.setOption(option);
    },

    load(val) {
      const { doc, image, pdf, ppt, video, voice } = val;
      this.data = [doc, image, pdf, ppt, video, voice];
      this.init();
    },
  },
};
</script>

<style scoped lang="scss">
.statistics-resource {
  width: 588px;
  background: #ffffff;
  border-radius: 8px;
  border: 1px solid #e6eaf0;
  > .title {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 600;
    color: #323233;
    line-height: 22px;
    padding: 24px 24px 0;
    > img {
      margin-right: 8px;
    }
  }
}
</style>
